// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"219":"ee3454a2","935":"ee3454a2"}[chunkId] + ".chunk.css";
};